/**
 * 获取指定字典编码的字典值数组
 * @param dictCode
 */
const getDictDtls = (dictCode) => {
    switch (dictCode) {
        case "PRJ_TYPE":
            return [
                { code: 'SLN', nameCn: '模型群', sortSeq: 1, licenseCode: 'M00030004' },
                { code: 'RP', nameCn: '需求池', sortSeq: 2 },
                { code: 'OM', nameCn: '组织模型', sortSeq: 16, licenseCode: 'M00020005' },
                { code: 'BM', nameCn: '流程模型', sortSeq: 17, licenseCode: 'M00020006' },
                { code: 'NEW', nameCn: 'BODA软件模型', sortSeq: 18, licenseCode: 'M00020001' },
                { code: 'ONLINE', nameCn: '部署模型', sortSeq: 19, licenseCode: 'M00020007' },
                { code: 'DM', nameCn: 'RDB库表模型', sortSeq: 20, licenseCode: 'M00020002' },
                { code: 'BAM', nameCn: 'STAR基准分析模型', sortSeq: 21, licenseCode: 'M00020003' },
                { code: 'TAM', nameCn: 'STAR主题分析模型', sortSeq: 22, licenseCode: 'M00020004' },
                { code: 'BCT', nameCn: '模件组资源', sortSeq: 22 },
                { code: 'LIB', nameCn: '建模资源', sortSeq: 23 },
                { code: 'KM', nameCn: '知识模型', sortSeq: 24 }
            ];
        case "PRJ_SUB_TYPE":
            return [
                { code: 'BODA1', nameCn: 'BODA1', sortSeq: 1 },
                { code: 'BODA2', nameCn: 'BODA2', sortSeq: 2 },
            ];
        // 知识模型 子类型
        case "KM_SUB_TYPE":
            return [
                { code: 'RMA', nameCn: '需求模型A', sortSeq: 1 },
                { code: 'RMB', nameCn: '需求模型B', sortSeq: 2 },
                { code: 'DK', nameCn: '领域知识', sortSeq: 3 },
            ];
        case "PRJ_BASELINE":
            return [
                { code: 'BASELINE', nameCn: '基线分支', sortSeq: 1 },
                { code: 'INCREMENT', nameCn: '增量分支', sortSeq: 2 },
            ];
        case "DES_TYPE":
            return [
                { code: 'PRODUCTION', nameCn: '投产', sortSeq: 1 },
                { code: 'PROGRAMME', nameCn: '方案', sortSeq: 2 },
            ];
        case "DES_STS":
            return [
                { code: 'DRAFT', nameCn: '草稿', sortSeq: 1 },
                { code: 'TO_CONFIRM', nameCn: '待确认', sortSeq: 2 },
                { code: 'CONFIRM', nameCn: '已确认', sortSeq: 3 },
                { code: 'ACCEPT', nameCn: '已验收', sortSeq: 4 },
            ];
        case "WHITE_LIST_TYPE":
            return [
                { code: 'PRJ', nameCn: '项目', sortSeq: 0 },
                { code: 'DB', nameCn: '数据库', sortSeq: 1 },
                { code: 'DT', nameCn: '数据表', sortSeq: 2 },
                { code: 'BDSUMMARY', nameCn: '用户场景', sortSeq: 3 },
                { code: 'BDLOGIC', nameCn: '接口程序能力', sortSeq: 4 },
                { code: 'BDRULE', nameCn: '数据实体', sortSeq: 5 },
                { code: 'UI', nameCn: '用户界面', sortSeq: 6 },
                { code: 'UE', nameCn: '界面事件能力', sortSeq: 7 },
            ];
        case "PRD_VERSION_TYPE":
            return [
                { code: 'AUTO', nameCn: '自动', sortSeq: 1 },
                { code: 'MANUAL', nameCn: '手动', sortSeq: 2 },
            ];
        case "DB_TYPE":
            return [
                { code: 'MYSQL', nameCn: 'MySQL', sortSeq: 1 },
                { code: 'ORACLE', nameCn: 'Oracle', sortSeq: 2 },
                { code: 'SQLSERVER', nameCn: 'SqlServer', SqlServer: 3 },
                { code: 'POSTGRESQL', nameCn: 'PostgreSQL', sortSeq: 4 },
                { code: 'OBFORMYSQL', nameCn: 'OceanBase(MySQL模式)', sortSeq: 5 },
                { code: 'OBFORORACLE', nameCn: 'OceanBase(Oracle模式)', sortSeq: 6 },
                { code: 'GBASE8S', nameCn: 'GBase 8s', sortSeq: 7 },
            ];
        case "ER_CATEGORY":
            return [
                { code: 'FILE_GEN', nameCn: '文件生成通知', sortSeq: 1 },
                { code: 'AI_WORKFLOW', nameCn: 'AI助手通知', sortSeq: 1 },
                { code: 'PATTERN_GEN', nameCn: '模型成品生成通知', sortSeq: 2 },
                { code: 'PATTERN_COMPARE_REPORT_GEN', nameCn: '模型比对报告生成通知', sortSeq: 3 },
                { code: 'BODA_STATEMENT_CHECK', nameCn: '语句规范性检查通知', sortSeq: 4 },
                { code: 'IMPORT_PRJ_DATA', nameCn: '导入项目数据通知', sortSeq: 5 },
                { code: 'IMPORT_PRJ_FILE', nameCn: '导入项目文件通知', sortSeq: 6 },
                { code: 'ONEKEY_CHANGE_HANDLE', nameCn: '一键处置变更通知', sortSeq: 7 },
            ];
        case "ER_OPT_TYPE":
            return [
                { code: 'NONE', nameCn: '无操作', sortSeq: 1 },
                { code: 'NEW_WINDOW', nameCn: '新页面', sortSeq: 2 },
            ];
        case "PATTERN_STS":
            return [
                { code: 'BUILDING', nameCn: '构建中', sortSeq: 1 },
                { code: 'BUILD_ERR', nameCn: '构建失败', sortSeq: 2 },
                { code: 'TO_REVISE', nameCn: '待修订', sortSeq: 3 },
                { code: 'CAN_BUILD', nameCn: '可构建成品', sortSeq: 4 },
                { code: 'BUILD', nameCn: '已构建成品', sortSeq: 5 },
                //{ code: 'TO_RLS', nameCn: '待发布', sortSeq: 6 },
                { code: 'RLS', nameCn: '已发布', sortSeq: 7 },
            ];
        case "PATTERN_COMPARE_REPORT_STS":
            return [
                { code: 'TO_ACCEPT', nameCn: '待受理', sortSeq: 1 },
                { code: 'COMPARING', nameCn: '比对中', sortSeq: 2 },
                { code: 'COMPARED', nameCn: '比对完成', sortSeq: 3 },
                { code: 'COMPARED_ERR', nameCn: '比对失败', sortSeq: 3 },
            ];
        case "PATTERN_MODULE_ERR_TYPE":
            return [
                { code: 'DP_NOT_EXIST', nameCn: '制品不存在', sortSeq: 1 },
                { code: 'DP_REV_ERR', nameCn: '制品版本错误', sortSeq: 2 },
                { code: 'MAP_VER_NOT_EXIST', nameCn: '发布版不存在', sortSeq: 3 },
                { code: 'MAP_VER_DATA_ERR', nameCn: '发布版数据异常', sortSeq: 4 },
                { code: 'REF_MODULE_INFO_ERR', nameCn: '引用模件信息异常', sortSeq: 5 },
                { code: 'REF_MODULE_NOT_EXIST', nameCn: '引用模件不存在', sortSeq: 6 },
                { code: 'REF_MODULE_PRJ_INFO_ERR', nameCn: '引用模件项目信息异常', sortSeq: 7 },
            ];
        case "MERGE_STS":
            return [
                { code: 'NOT_START', nameCn: '未开始', sortSeq: 1 },
                { code: 'PROCESSING', nameCn: '合并处理中', sortSeq: 2 },
                { code: 'PART_MERGED', nameCn: '已部分合并', sortSeq: 3 },
                { code: 'FINISH_MERGED', nameCn: '已完成合并', sortSeq: 4 },
                { code: 'FAIL_MERGED', nameCn: '合并失败', sortSeq: 5 },
            ];
        case "BF_TYPE_CODE":
            return [
                { code: 'TARGET', nameCn: 'SOP', sortSeq: 1 },
                { code: 'TARGET2', nameCn: '端到端', sortSeq: 2 },
            ];
        case "RM_TYPE":
            return [
                { code: 'SUMMARY', nameCn: '需求架构', sortSeq: 1 },
                { code: 'ARCH_SYS', nameCn: '系统架构', sortSeq: 2 },
                { code: 'DOMAIN_KNOWLEDGE', nameCn: '领域知识', sortSeq: 3 },
                { code: 'STANDARD', nameCn: '建模技能', sortSeq: 4 },
                { code: 'COMMON', nameCn: '其他', sortSeq: 5 }
            ];
        case "TERMINAL_TYPE":
            return [
                { code: 'PC', nameCn: 'PC', sortSeq: 1 },
                { code: 'MOBILE', nameCn: '移动端', sortSeq: 2 },
                { code: 'PAD', nameCn: 'PAD', sortSeq: 3 },
            ];
        case "LS_TYPE":
            return [
                { code: 'IS', nameCn: '独立系统', sortSeq: 1 },
                { code: 'CC', nameCn: '通用组件', sortSeq: 2 },
            ];
        // 后端增量逆向清单-变更状态
        case "REV_BE_DELTA_CHANGE_STS":
            return [
                { code: 'ADD_MODULE', nameCn: '新增程序模块', sortSeq: 1 },
                { code: 'ADD_FEATURE', nameCn: '新增程序能力', sortSeq: 2 },
                { code: 'UPT_FEATURE', nameCn: '更新程序能力', sortSeq: 3 },
            ];
        // 前端增量逆向清单-变更状态
        case "REV_FE_DELTA_CHANGE_STS":
            return [
                { code: 'ADD_UI', nameCn: '新增用户界面', sortSeq: 1 },
                { code: 'ADD_EVENT', nameCn: '新增界面事件能力', sortSeq: 2 },
                { code: 'UPT_EVENT', nameCn: '更新界面事件能力', sortSeq: 3 },
            ];
        // 增量逆向主记录-增量批次后端状态
        case "REV_BE_BATCH_STS":
            return [
                { code: 'DRAFT', nameCn: '草稿', sortSeq: 1 },
                { code: 'IMPORTED', nameCn: '已导入', sortSeq: 2 },
                { code: 'RLS', nameCn: '发布', sortSeq: 3 },
                { code: 'CLOSED', nameCn: '关闭', sortSeq: 4 },
            ];
        // 增量逆向主记录-增量批次前端状态
        case "REV_FE_BATCH_STS":
            return [
                { code: 'DRAFT', nameCn: '草稿', sortSeq: 1 },
                { code: 'IMPORTED', nameCn: '已导入', sortSeq: 2 },
                { code: 'RLS', nameCn: '发布', sortSeq: 3 },
                { code: 'CLOSED', nameCn: '关闭', sortSeq: 4 },
            ];
    }
    return [];
}


/**
 * 获取指定字典编码、字典值编码的字典值对象
 * @param dictCode
 * @param dictItemCode
 * @returns {string|*|string}
 */
const getDictDtl = (dictCode, dictItemCode) => {
    const data = getDictDtls(dictCode);
    if (data) {
        return data.find(item => item.code == dictItemCode);
    }
    return null;
}

const dict = {
    getDictDtls,
    getDictDtl
};

export default dict;
